import * as React from 'react';
import Avatar from 'antd/lib/avatar';
import Segmented, { SegmentedLabeledOption } from 'antd/lib/segmented';
import ConfigProvider from 'antd/lib/config-provider';
import { useSidebarColors } from '../../styles/themeMode';
import { AppPlatform } from '../../../types';
import { Destination } from '../../../types/destinations';
import WorkflowsPlatformIcon from '../../icons/WorkflowsPlatformIcon';

export const PlatformIconBox: React.FC<{
    platform: AppPlatform;
    size?: number;
}> = ({ platform, size = 28 }) => {
    return <WorkflowsPlatformIcon platform={platform} width={size} height={size} />;
};

export const DestinationIcon: React.FC<{
    destination: Destination;
    size?: number;
}> = ({ destination, size = 16 }) => {
    const sc = useSidebarColors();

    if (destination.iconURL) {
        return (
            <Avatar
                shape="square"
                size={size}
                src={destination.iconURL}
                style={{
                    borderRadius: size * 0.17,
                    flexShrink: 0,
                }}
            />
        );
    }

    const letter = destination.name?.charAt(0);

    if (letter) {
        return (
            <Avatar
                shape="square"
                size={size}
                style={{
                    borderRadius: size * 0.17,
                    backgroundColor: sc.icon,
                    fontSize: Math.round(size * 0.7),
                    flexShrink: 0,
                }}
            >
                {letter}
            </Avatar>
        );
    }

    return <WorkflowsPlatformIcon platform={destination.platform} width={size} height={size} />;
};

export const NavigationSegmented: React.FC<{
    value: string;
    onChange: (value: string | number) => void;
    options: SegmentedLabeledOption[];
    style?: React.CSSProperties;
}> = ({ value, onChange, options, style = {} }) => {
    const sc = useSidebarColors();
    const navigationSegmentedTheme = {
        components: {
            Segmented: {
                trackBg: sc.segmentedBg,
                trackPadding: 4,
                itemColor: sc.icon,
                itemHoverColor: sc.textSecondary,
                itemHoverBg: 'transparent',
                itemSelectedBg: sc.segmentedActiveBg,
                itemSelectedColor: sc.text,
                itemBorder: sc.border,
            },
        },
    };
    return (
        <ConfigProvider theme={navigationSegmentedTheme}>
            <Segmented
                block
                value={value}
                onChange={onChange}
                className="app-menu-segmented"
                style={{ ...style, borderRadius: 8 }}
                options={options}
            />
        </ConfigProvider>
    );
};
